<div class="m-timepicker"
     :class="{
        'm--has-validation-message': timeError || hasValidationMessage
    }"
     :style="{ width: inputWidth, maxWidth: inputMaxWidth }"
     @click="onClick">
    <m-input-style v-m-popup:popup
                   class="m-timepicker"
                   :disabled="isDisabled"
                   :readonly="isReadonly"
                   :waiting="isWaiting"
                   :focus="isFocus"
                   :required-marker="requiredMarker"
                   :label-up="labelUp || currentTime"
                   :label="label"
                   :label-for="id"
                   :empty="isEmpty"
                   :error="timeError"
                   :valid="isValid"
                   :error-message="errorMessage"
                   :valid-message="validMessage"
                   :helper-message="helperMessage"
                   :style="{ width: inputWidth, maxWidth: inputMaxWidth }">
        <m-input-mask v-model="currentTime"
                      ref="input"
                      :id="id"
                      :disabled="isDisabled"
                      :readonly="isReadonly || isWaiting"
                      inputmode="decimal"
                      :options="inputMaskOptions"
                      :placeholder="i18nPlaceHolder"
                      :min="min"
                      :max="max"
                      :step="currentStep"
                      type="text"
                      :raw="false"
                      :aria-invalid="timeError"
                      :aria-label="inputAriaLabel"
                      :aria-describedby="validationMessageId"
                      :required="required || requiredMarker"
                      @change="emitChange(currentTime)"
                      @blur="onBlur"
                      @focus="onFocus" />
        <m-icon-button slot="suffix"
                       icon-name="m-svg__clock"
                       :disabled="!active"
                       button-size="22px"
                       tabindex="-1"
                       aria-hidden="true"
                       :title="!open ? $i18n.translate('m-timepicker:open') : $i18n.translate('m-timepicker:close')"
                       @click="togglePopup($event)" />
        <m-popup slot="popup"
                 ref="popup"
                 :open.sync="open"
                 :disabled="!active"
                 :padding="false"
                 :focus-management="false"
                 open-trigger="manual"
                 placement="bottom-end"
                 @open="onOpen"
                 @close="onClose">
            <div slot="header"
                 class="m-timepicker__header">
                <span class="m-timepicker__header__hours">{{ $i18n.translate('m-timepicker:hours') }}</span>:
                <span class="m-timepicker__header__minutes">{{ $i18n.translate('m-timepicker:minutes') }}</span>
            </div>
            <div class="m-timepicker__body">
                <ul class="m-timepicker__hours"
                    ref="hours"
                    role="listbox"
                    @mousedown="onMousedown"
                    @mouseup="onMouseup"
                    @scroll="onScroll">
                    <li v-for="(h, hoursIndex) in currentfilteredHours"
                        :key="hoursIndex"
                        :id="h"
                        class="m-timepicker__hours-item">
                        <m-calendar-button :selected="h == currentHour"
                                           role="option"
                                           @click="onSelectHour(h)"
                                           @keyup="onSelectHourKeyup($event, h)">
                            {{formatNumber(h)}}
                        </m-calendar-button>
                    </li>
                </ul>
                <ul class="m-timepicker__minutes"
                    ref="minutes"
                    @mousedown="onMousedown"
                    @mouseup="onMouseup"
                    @scroll="onScroll">
                    <li v-for="(m, minutesIndex) in currentFilteredMinutes"
                        :key="minutesIndex"
                        :id="minutesIndex"
                        class="m-timepicker__minutes-item">
                        <m-calendar-button :selected="m == currentMinute"
                                           @click="onSelectMinute(m)"
                                           @keyup="onSelectMinuteKeyup($event, m)"
                                           role="option">
                            {{formatNumber(m)}}
                        </m-calendar-button>
                    </li>
                </ul>
            </div>
            <div slot="footer"
                 class="m-timepicker__footer">
                <m-link mode="button"
                        @click="onOk">{{i18nButton}}</m-link>
            </div>
        </m-popup>
    </m-input-style>
    <m-validation-message :id="validationMessageId"
                          class="m-timepicker__validation-message"
                          :disabled="isDisabled"
                          :waiting="isWaiting"
                          :error="timeError"
                          :error-message="timeErrorMessage"
                          :valid-message="validMessage"
                          :helper-message="helperMessage" />
</div>
